import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { customerInteractionSchema } from "@common/components/helpers/validation-schemas/customerInteractionSchema";
import CustomerInteractionAction from "@common/redux/actions/CustomerInteractionAction";
import useCompliance from "./useCompliance";
import GuardianClient from "@common/api/GuardianClient";

const useCustomerInteraction = () => {
  const data = useSelector((state) =>
    CustomerInteractionAction.getStatePath(state),
  );

  const setState = CustomerInteractionAction.dispatch;

  const [config, setConfig] = useState({
    hasSetVulnerable: false,
    hasSetTemporaryBreak: false,
  });

  const methods = useForm({
    resolver: yupResolver(customerInteractionSchema(config)),
    defaultValues: data,
    mode: "all",
  });

  const { resetComplianceForms } = useCompliance(methods);

  useEffect(() => {
    GuardianClient.getCustomerInteractionConfig().then((response) => {
      const newConfig = {
        hasSetVulnerable: Boolean(response?.hasSetVulnerable),
        hasSetTemporaryBreak: Boolean(response?.hasSetTemporaryBreak),
      };

      setConfig(newConfig);
    });
  }, []);

  const handleBack = () => resetComplianceForms();

  return {
    ...data,
    methods,
    handleBack,
    setState,
    config
  };
};

export default useCustomerInteraction;
